import { Pipe, PipeTransform } from '@angular/core';
import {DateTimeService} from '../date-time.service';

@Pipe({
  name: 'localdatetime'
})
export class LocalDatetimePipe implements PipeTransform {

  constructor(private dateTimeService: DateTimeService) {
  }

  transform(utcStringDatatTime: string, complete: boolean = true): string {
    return this.dateTimeService.toLocalStringDateTime(utcStringDatatTime, complete);
  }
}
